import { Text, View } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { currency, longDate } from '../lib/format';

export default function TransactionRow({ transaction }) {
  const isExpense = transaction.type === 'expense';

  return (
    <View className="mb-3 rounded-2xl border border-slate-200 bg-white p-4">
      <View className="flex-row items-start justify-between gap-3">
        <View className="flex-1 flex-row gap-3">
          <View className={`h-10 w-10 items-center justify-center rounded-full ${isExpense ? 'bg-rose-50' : 'bg-emerald-50'}`}>
            <MaterialIcons name={isExpense ? 'trending-down' : 'trending-up'} size={20} color={isExpense ? '#e11d48' : '#059669'} />
          </View>
          <View className="flex-1">
            <Text className="text-base font-bold text-slate-950">{transaction.item || transaction.category}</Text>
            <Text className="mt-1 text-sm text-slate-500">{transaction.category} | {longDate(transaction.date)}</Text>
            {transaction.notes ? <Text className="mt-2 text-sm text-slate-600">{transaction.notes}</Text> : null}
            {transaction.sub_expenses?.length ? (
              <View className="mt-3 rounded-xl bg-slate-50 p-3">
                {transaction.sub_expenses.slice(0, 4).map((sub, index) => (
                  <View key={`${sub.item}-${index}`} className="mb-1 flex-row justify-between gap-3">
                    <Text className="flex-1 text-xs font-semibold text-slate-600">{sub.item}</Text>
                    <Text className="text-xs font-bold text-slate-700">{currency(sub.amount)}</Text>
                  </View>
                ))}
                {transaction.sub_expenses.length > 4 ? <Text className="mt-1 text-xs text-slate-500">+{transaction.sub_expenses.length - 4} more</Text> : null}
              </View>
            ) : null}
          </View>
        </View>
        <Text className={`text-base font-bold ${isExpense ? 'text-rose-600' : 'text-emerald-600'}`}>
          {isExpense ? '-' : '+'}{currency(transaction.amount)}
        </Text>
      </View>
    </View>
  );
}
